module.exports = "/_next/static/images/a9788136fca8d42493b3d4d5f2f2747b-card.svg.webp";